import { render, staticRenderFns } from "./third-customer.vue?vue&type=template&id=1f535228&scoped=true&"
import script from "./third-customer.vue?vue&type=script&lang=ts&"
export * from "./third-customer.vue?vue&type=script&lang=ts&"
import style0 from "./third-customer.vue?vue&type=style&index=0&id=1f535228&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f535228",
  null
  
)

export default component.exports